"use client";

import { authLogin } from "@/entities";
import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";

export function AdminLoginPage() {
  const router = useRouter();

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const loginMutation = useMutation({
    mutationFn: authLogin,
    onSuccess: () => {
      router.push("/admin/main");
    },
    onError: (e: any) => {
      toast.error(`에러(${e.message})가 발생했습니다. 다시 시도해 주세요.`);
    },
  });

  const onSubmit = async (data: any) => {
    if (loginMutation.isPending) return;
    await loginMutation.mutateAsync(data);
  };

  return (
    <>
      <div className="login login-v1">
        <div className="login-container">
          <div className="login-header">
            <div className="brand">
              <div className="d-flex align-items-center">
                <span className="logo"></span> <b>위즈온</b> 관리자
              </div>
              <small>위즈온 관리자 페이지 입니다.</small>
            </div>
            <div className="icon">
              <i className="fa fa-lock"></i>
            </div>
          </div>
          <div className="login-body">
            <div className="login-content fs-13px">
              <form onSubmit={handleSubmit(onSubmit)}>
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: "이메일을 입력해주세요.",
                  }}
                  render={({ field: { onChange, onBlur, value } }) => (
                    <>
                      <div className="form-floating mb-20px">
                        <input
                          type="email"
                          id="email"
                          title="이메일을 입력해주세요."
                          placeholder="이메일을 입력해주세요."
                          className="form-control fs-13px h-45px"
                          onChange={onChange}
                          onBlur={onBlur}
                          value={value || ""}
                        />
                        <label
                          htmlFor="email"
                          className="d-flex align-items-center py-0"
                        >
                          이메일
                        </label>
                        {errors.email && (
                          <span className="text-red errorText">
                            {errors.email.message as string}
                          </span>
                        )}
                      </div>
                    </>
                  )}
                />

                <Controller
                  name="password"
                  control={control}
                  rules={{
                    required: "비밀번호를 입력해주세요.",
                  }}
                  render={({ field: { onChange, onBlur, value } }) => (
                    <>
                      <div className="form-floating mb-20px">
                        <input
                          type="password"
                          id="password"
                          title="비밀번호를 입력해주세요."
                          placeholder="비밀번호를 입력해주세요."
                          className="form-control fs-13px h-45px"
                          onChange={onChange}
                          onBlur={onBlur}
                          value={value || ""}
                        />
                        <label
                          htmlFor="email"
                          className="d-flex align-items-center py-0"
                        >
                          비밀번호
                        </label>
                        {errors.password && (
                          <span className="text-red errorText">
                            {errors.password.message as string}
                          </span>
                        )}
                      </div>
                    </>
                  )}
                />

                <div className="login-buttons">
                  <button
                    type="submit"
                    className="btn h-45px btn-theme d-block w-100 btn-lg"
                  >
                    로그인
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
